import { mergeRight, without, append, uniq } from 'ramda'

const defaultState = {
  contacts: [],
  selectedContacts: []
}

const contacts = (state = defaultState, action) => {
  switch (action.type) {
    case 'RECEIVE_CONTACTS':
      return mergeRight(state, {
        contacts: action.contacts
      })

    case 'SELECT_CONTACT':
      if (Array.isArray(action.selectedId)) {
        return mergeRight(state, {
          selectedContacts: uniq(action.selectedId)
        })
      } else {
        return mergeRight(state, {
          selectedContacts: uniq(append(action.selectedId, state.selectedContacts))
        })
      }

    case 'DESELECT_CONTACT':
      const removed = Array.isArray(action.deselectedId) ? action.deselectedId : [action.deselectedId]
      return mergeRight(state, {
        selectedContacts: without(removed, state.selectedContacts)
      })
      
    default:
      return state
  }
}

export default contacts